import { generateLabelsAndValues } from "../utils/helperFunctions";

export const CheckoutSessionTypes = {
    // GT_QT: 1,
    // PT_CT: 2,
    // CERTIFICATE_RENEWAL: 3,
    // ATP_PROFILE: 4,
    // ASSESSMENT: 5,
    // ATP_RENEWAL: 6,
    GT: 1,
    TS: 2,
    TS_CERTIFICATE_RENEWAL: 3,
    ATP_PROFILE: 4,
    TS_ASSESSMENT: 5,
    ATP_RENEWAL: 6,
    TC: 7,
    TC_ASSESSMENT: 8,
    TC_CERTIFICATE_RENEWAL: 9,
    QT: 10,
    TS_ASSESSMENT_FAILED: 11,
    TC_ASSESSMENT_FAILED: 12,
};

export const PaymentStatus = {
    PENDING: 1,
    SUCCESS: 2,
    FAILED: 3,
    CANCELLED: 4,
};

export const TransactionStatus = {
    1: "Pending",
    2: "Payment Successful",
    3: "Payment Failed",
    4: "Payment Cancelled",
};

export const ApplicationType = {
    GRADUATE_TECHNOLOGIST: 1,
    QUALIFIED_TECHNICIAN: 2,
    TS_CERTIFICATE_FEE: 3,
    TC_CERTIFICATE_FEE: 4,
    TS_ASSESSMENT: 5,
    TC_ASSESSMENT: 6,
    ATP_REGISTRATION: 7,
    PROFESSIONAL_TECHNOLOGIST_RENEWAL: 8,
    CERTIFIED_TECHNICIAN_RENEWAL: 9,
    ATP_RENEWAL: 10,
};


// Helper function to generate labels and values
const generateCustomLabelsAndValues = (obj) => {
    return Object.entries(obj).map(([key, value]) => {
        let label = key.replace(/_/g, " ");

        // Interchanging specific labels
        if (key === "TS_ASSESSMENT") {
            label = "Ts. CERTIFICATE FEE";
        } else if (key === "TS_CERTIFICATE_FEE") {
            label = "Ts. ASSESSMENT";
        } else if (key === "TC_ASSESSMENT") {
            label = "Tc. CERTIFICATE FEE";
        } else if (key === "TC_CERTIFICATE_FEE") {
            label = "Tc. ASSESSMENT";
        }

        return { label, value };
    });
};

export const PreferredApplicationType = generateCustomLabelsAndValues(ApplicationType);

export const findPreferredApplicationType = (value) => {
    const data = PreferredApplicationType.find((ele) => ele.value == value);
    return data?.label;
};
